import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
export var generateWebsiteUrl = function generateWebsiteUrl(url) {
  if (!url) return "";
  try {
    var parsed = new _URL(url);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return parsed.href;
    }
    return "";
  } catch (_unused) {
    // url had no scheme — prepend https:// and validate
    try {
      var withScheme = new _URL("https://".concat(url));
      if (withScheme.protocol === "https:") {
        return withScheme.href;
      }
      return "";
    } catch (_unused2) {
      return "";
    }
  }
};
export var capitalizeFirstLetter = function capitalizeFirstLetter(text) {
  var _text$charAt;
  return (text === null || text === void 0 || (_text$charAt = text.charAt(0)) === null || _text$charAt === void 0 ? void 0 : _text$charAt.toUpperCase()) + (text === null || text === void 0 ? void 0 : _sliceInstanceProperty(text).call(text, 1));
};
var _stripNonLatin = function stripNonLatin1(v) {
  if (typeof v === "string") return v.replace(/[\u0100-\uFFFF]/g, "");
  if (_Array$isArray(v)) return _mapInstanceProperty(v).call(v, _stripNonLatin);
  return v;
};
export { _stripNonLatin as stripNonLatin1 };
export var colorVariablesFormat = function colorVariablesFormat(primaryColor, secondaryColor) {
  return {
    "--primary-color": primaryColor,
    "--secondary-color": secondaryColor
  };
};

/**
 * Formats city, state, and postal code into a string.
 * Format: "city, state postalCode" - city and state separated by comma, state and postalCode by space
 *
 * @param city - City name
 * @param state - State abbreviation
 * @param postalCode - Postal/ZIP code
 * @param removeExtra4Digits - Whether to remove the extra 4 digits from ZIP+4 format (default: true)
 * @returns Formatted city/state/zip string
 */
export var formatCityStateZip = function formatCityStateZip(city, state, postalCode) {
  var removeExtra4Digits = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var cityTrimmed = (city === null || city === void 0 ? void 0 : _trimInstanceProperty(city).call(city)) || "";
  var stateTrimmed = (state === null || state === void 0 ? void 0 : _trimInstanceProperty(state).call(state)) || "";
  var postalCodeTrimmed = (postalCode === null || postalCode === void 0 ? void 0 : _trimInstanceProperty(postalCode).call(postalCode)) || "";

  // Remove the extra 4 digits from ZIP+4 format (e.g., "94107-1234" -> "94107")
  if (removeExtra4Digits && postalCodeTrimmed && _includesInstanceProperty(postalCodeTrimmed).call(postalCodeTrimmed, "-")) {
    postalCodeTrimmed = postalCodeTrimmed.split("-")[0];
  }
  var addr = "";
  if (cityTrimmed) {
    addr = cityTrimmed;
    if (stateTrimmed) {
      addr += ", ".concat(stateTrimmed);
    }
    if (postalCodeTrimmed) {
      addr += stateTrimmed ? " ".concat(postalCodeTrimmed) : ", ".concat(postalCodeTrimmed);
    }
  } else if (stateTrimmed) {
    addr = stateTrimmed;
    if (postalCodeTrimmed) {
      addr += " ".concat(postalCodeTrimmed);
    }
  } else if (postalCodeTrimmed) {
    addr = postalCodeTrimmed;
  }
  return addr;
};